import React, { useEffect, useState } from "react";
import useBreadcrumbs, { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';
import { NavLink } from 'react-router-dom';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import NewEventService from '../services/NewEvent.service';
import { DeclarationService } from "../services/declaration/declarationService";
import { TruncateUtils } from "../helpers/HelpersFunc";

// Dynamic breadcrumb component for event name
const EventBreadcrumb: BreadcrumbComponentType = () => {
    const [eventName, setEventName] = useState('');

    useEffect(() => {
        const subscription = NewEventService.eventData.subscribe(value =>
            setEventName(TruncateUtils.truncateText(value?.eventName) || '')
        );
        return () => subscription.unsubscribe();
    }, []);

    return <span>{eventName || 'Event'}</span>;
};

// Dynamic breadcrumb component for declaration name
const DeclarationBreadcrumb: BreadcrumbComponentType = () => {
    const [declarationName, setDeclarationName] = useState('');

    useEffect(() => {
        const subscription = DeclarationService.declarationData.subscribe(value =>
            setDeclarationName(value?.declarationName || '')
        );
        return () => subscription.unsubscribe();
    }, []);

    return <span>{declarationName || 'Declaration'}</span>;
};

// Routes configuration for breadcrumbs
const routes = [
    { path: '/dashboard', breadcrumb: 'List of Events' },
    { path: '/dashboard/event', breadcrumb: null },
    { path: '/dashboard/event/new', breadcrumb: 'New Event' },
    { path: '/dashboard/event/:mode', breadcrumb: null },
    { path: '/dashboard/event/:mode/:id', breadcrumb: EventBreadcrumb },
    { path: '/dashboard/event/:mode/:id/:idd', breadcrumb: DeclarationBreadcrumb },
    { path: '/dashboard/event/:mode/:id/:idd/readonly', breadcrumb: null },
    { path: '/declaration', breadcrumb: null },
    { path: '/declaration/new', breadcrumb: 'New Declaration' },
    { path: '/declaration/:id', breadcrumb: 'Declaration' },
    { path: '/admin', breadcrumb: 'Administration' },
];

export const AppBreadcrumbs = () => {
    const breadcrumbs = useBreadcrumbs(routes, { excludePaths: ['/'] });

    // Filter out null breadcrumbs
    const filteredBreadcrumbs = breadcrumbs.filter(({ breadcrumb }) => breadcrumb !== null);

    return (
        <ol className="breadcrumb">
            {filteredBreadcrumbs.map(({ match, breadcrumb }, index) => {
                const isLast = index === filteredBreadcrumbs.length - 1;

                return isLast ? (
                    <li key={match.pathname} className="breadcrumb-item active">
                        {breadcrumb}
                    </li>
                ) : (
                    <li key={match.pathname} className="breadcrumb-item">
                        <NavLink to={match.pathname}>{breadcrumb}</NavLink>
                        <ArrowRightIcon />
                    </li>
                );
            })}
        </ol>
    );
};